import ButtonBase from '@mui/material/ButtonBase/ButtonBase';
import React from 'react';
import { Theme, useTheme } from '@mui/material/styles';
import { createUseStyles } from 'react-jss';
import Soon from '../../components/soon/Soon';

interface ITabProps {
  title: string;
  value: string;
  soon?: boolean;
  onClick: (s: string) => void;
}
export default function Tab({ title, value, onClick, soon = false }: ITabProps) {
  const theme = useTheme();
  const useStyles = createUseStyles((theme: Theme) => ({
    tabIndicator: { background: theme.palette.primary.main, width: 4, height: '100%', position: 'absolute', left: 0, top: 0 },
  }));

  const classes = useStyles({ theme });
  return (
    <ButtonBase onClick={() => onClick(title)} style={{ display: 'flex' }}>
      {title == value && <span className={classes.tabIndicator} />}
      <div style={{ flex: '1 1 auto', display: 'flex', alignItems: 'center' }}>
        {title}
        {soon && <Soon />}
      </div>
    </ButtonBase>
  );
}
